// It will return the first option in the menu, for authenticated users.
// For anonymous, it will redirect to the login page.
//
// If there are no options available it will forward to forbidden,
// because we assume the user isn't allowed to access the application
//
// Can be overridden by a /localresource/customizations.js file,
// for a specific install.
//
// conf:
// * `loginUri`: the loginUri
// * `forbiddenUri`: the forbidden uri
var FirstMenuSelectionStrategy = function(core, conf) {

    var _override;

    return {
        getDefaultModuleUri: function() {
            if(_override) return _override(core);

            if (core.getCurrentLoggedInUser() === 'anonymous') {
                return conf.loginUri;
            }

            var options = core.getAppInfoModel().opts;

            if (options && options.length > 0) {
                return options[0].href;

            } else {
                return conf.forbiddenUri;
            }
        },

        overrideWith: function(override){
            _override = override;
        }
    }
};

export default FirstMenuSelectionStrategy;
